export const baseUrl = "https://whitelabel.truevals.com/api/v1";
// export const baseUrl = "http://localhost:3002/api/v1";